/* @ngInject */
const ask = (
  ownerLocal,
  ownerFormat,
  ownerRequest,
  ownerData,
  toaster,
  valueHandler,
  utils,
  ownerLabels
) => {
  const self = {}

  self.delete = async (_id, _back = null) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(ownerLabels.ask.delete)) {
      try {
        const message = await ownerRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(ownerData.myOwners, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_owner, _back = null) => {
    let owner = utils.copy(_owner)
    owner.id = ownerLocal.getCurrentId()
    owner = ownerFormat.server(owner)

    try {
      const response = await ownerRequest.update(owner)
      toaster.message(response.message)
      utils.updateFromArray(ownerData.myOwners, response.owner)
      if (_back) { utils.$back() }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/ask.service.js